<template>
  <div class="carousel">
    <slot :currentSlide="currentSlide" />

    <!-- Navigation -->
    <div
      v-if="navEnabled"
      class="navigate absolute flex mx-auto h-[100px] gap-4 w-full justify-center bottom-[45px]"
    >
      <div class="toggle-page-left">
        <img
          @click="prevSlide"
          class="w-[50px] h-[50px] cursor-pointer px-auto"
          :src="
            $filters.media_path(
              '/images/testimonial-simple-arrow-left-light-grey.svg'
            )
          "
          alt="left"
        />
      </div>
      <div class="toggle-page-right">
        <img
          @click="nextSlide"
          class="w-[50px] h-[50px] cursor-pointer justify-center"
          :src="
            $filters.media_path(
              '/images/testimonial-simple-arrow-right-light-grey.svg'
            )
          "
          alt="right"
        />
      </div>
    </div>
    <!-- Pagination -->

    <div
      v-if="paginationEnabled"
      class="pagination absolute w-full flex justify-center gap-4 bottom-[30px]"
    >
      <span
        @click="goToSlide(index)"
        class="cursor-pointer w-[15px] h-[15px] bg-[#b9bec788] shadow-xl rounded-full"
        v-for="(slide, index) in getSlideCount"
        :key="index"
        :class="{ active: index + 1 == currentSlide }"
      >
      </span>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  props: ['startAutoPlay', 'timeout', 'navigation', 'pagination'],
  setup(props) {
    const currentSlide = ref(1);
    const getSlideCount = ref(null);
    const autoplayEnabled = ref(
      props.startAutoPlay == undefined ? true : props.startAutoPlay
    );
    const timeoutDuration = ref(
      props.timeout == undefined ? 5000 : props.timeout
    );
    const paginationEnabled = ref(
      props.pagination == undefined ? true : props.pagination
    );
    const navEnabled = ref(
      props.navigation == undefined ? true : props.navigation
    );

    // next slide
    const nextSlide = () => {
      if (currentSlide.value === getSlideCount.value) {
        currentSlide.value = 1;
        return;
      }

      currentSlide.value += 1;
    };

    // previous slide
    const prevSlide = () => {
      if (currentSlide.value === 1) {
        currentSlide.value = 1;
        return;
      }
      currentSlide.value -= 1;
    };

    const goToSlide = (index) => {
      currentSlide.value = index + 1;
    };

    // autoplay

    const autoplay = () => {
      setInterval(() => {
        nextSlide();
      }, timeoutDuration.value);
    };

    if (autoplayEnabled.value) {
      autoplay();
    }

    onMounted(() => {
      getSlideCount.value = document.querySelectorAll('.slide').length;
    });

    return {
      currentSlide,
      nextSlide,
      prevSlide,
      getSlideCount,
      goToSlide,
      paginationEnabled,
      navEnabled
    };
  },

  components: {}
};
</script>

<style scoped>
.active {
  background-color: #2d8cff;
}
</style>
